export const ACTIONS = {
  VIEW: 'VIEW',
  DISPUTE: 'DISPUTE',
  INITIATE: 'INITIATE',
  ADD: 'ADD',
  EDIT: 'EDIT'
}

export const SUBJECTS = {
  REBATES_DASHBOARD: 'Rebates',
  INVOICE_DETAILS: 'INVOICE_DETAILS',
  INVOICE: 'INVOICE',
  MARKETPLACE_AR: 'Marketplace AR',
  PAYMENT: 'PAYMENT',
  MARKETPLACE_AR_PAYMENT: 'MARKETPLACE_AR_PAYMENT',
  BUSINESS_RESOURCE: 'BUSINESS_RESOURCE',
  ADMIN_SUBTABS: 'ADMIN_SUBTABS',
  ADMIN_SPLIT_FEES: 'Split fees',
  ADMIN_TAB: 'Admin',
  ADMIN_PAYMENT: 'ADMIN_PAYMENT',
  COGNUS_AR_HS_NAME: 'COGNUS_AR_HS_NAME',
  REBATES_PAYMENT: 'REBATES_PAYMENT',
  COMPLETE_REBATES_PAYMENT: 'COMPLETE_REBATES_PAYMENT',
  COGNUS_AR_INVOICES_DETAILS: 'COGNUS_AR_INVOICES_DETAILS',
  COGNUS_AR_INVOICES_INITIATE_DISPUTE: 'COGNUS_AR_INVOICES_INITIATE_DISPUTE',
  COMPLETE_MARKETPLACE_AR_PAYMENT: 'COMPLETE_MARKETPLACE_AR_PAYMENT',
  REBATES_HS_NAME: 'REBATES_HS_NAME',
  REBATES_INVOICES: 'REBATES_INVOICES',
  ADMIN_HS_NAME: 'ADMIN_HS_NAME',
  SPLIT_FEES_GPO_TAB: 'SPLIT_FEES_GPO_TAB',
  SPLIT_FEES_COMMUNITY_TAB: 'SPLIT_FEES_COMMUNITY_TAB',
  SPLIT_FEES_PROCESSING_TAB: 'SPLIT_FEES_PROCESSING_TAB',
  GPO_COMMUNITY_DATA: 'GPO_COMMUNITY_DATA'
}
